import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const checkStatusShop = () => axios({
  method: 'get',
  url: config.endpoints.smartChatEcommerce.statusShop,
  headers: getHeaders(true)
})

export default {
  checkStatusShop
}
